class Sovendus extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.discountCookie = this.getCookie("discount_code");
    this.sovendusOpened = this.getCookie("sovendusModalOpened");
    this.sovendus20Opened = this.getCookie("sovendus20ModalOpened");
    this.init();
  }

  init() {
    if (!this.discountCookie) return;

    const code = this.discountCookie.toLowerCase();
    const isStandardCode =
      code.indexOf("so_") !== -1 ||
      code.indexOf("so-") !== -1 ||
      code.indexOf("zu99cu") !== -1;
    const is20Code =
      code.indexOf("so20_") !== -1 || code.indexOf("so20-") !== -1;

    if (isStandardCode) {
      this.submitForm("standard");
    } else if (is20Code) {
      this.submit20Form();
    }
  }

  submitForm(type) {
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);

    if (type === "standard") {
      formData.append("properties[_free_gift]", this.discountCookie);
      formData.append("properties[_code_id]", "so-");
    }

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (type === "standard") {
          const modal = document.querySelector("#SovendusModal");
          if (modal && this.sovendusOpened !== this.discountCookie) {
            modal.show(document.activeElement);
            document.cookie = `sovendusModalOpened=${this.discountCookie};`;
          }
        } else {
          const modal20 = document.querySelector("#Sovendus20Modal");
          if (modal20 && this.sovendus20Opened !== this.discountCookie) {
            modal20.show(document.activeElement);
            document.cookie = `sovendus20ModalOpened=${this.discountCookie};`;
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  submit20Form() {
    // Only apply discount, don't add free product
    const modal20 = document.querySelector("#Sovendus20Modal");
    if (modal20 && this.sovendus20Opened !== this.discountCookie) {
      modal20.show(document.activeElement);
      document.cookie = `sovendus20ModalOpened=${this.discountCookie};`;
    }
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }
}

customElements.define("sovendus-discount", Sovendus);
